import './App.css';

function App() {
  return (
    <div className="App">
        <h1>All In One</h1>
    </div>
  );
}

export default App;
